export default __webpack_public_path__ + "static/media/Zahl-2.999c2a1c.webp";